import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type { OpsRouteRun, OpsRouteRunsPage } from '../types/route-run.type';

interface GenericResponse<T> {
  result: T;
}

/** Every truck's run in a date range (inclusive) -- a day, a week, a month. */
export async function listRouteRunsForRange(
  organizationId: string,
  dateFrom: string,
  dateTo: string
): Promise<OpsRouteRunsPage> {
  const response = (await makeRequest({
    url: '/ops/route-runs',
    method: HttpMethods.GET,
    params: { organization_id: organizationId, date_from: dateFrom, date_to: dateTo },
  })) as GenericResponse<OpsRouteRunsPage>;
  return response.result;
}

/** Every truck's run for one day -- the Trips monitoring view. */
export async function listRouteRunsForDay(
  organizationId: string,
  runDate: string
): Promise<OpsRouteRunsPage> {
  return listRouteRunsForRange(organizationId, runDate, runDate);
}

/** One run in full -- the trip details page and its printable report. */
export async function getOpsRouteRun(organizationId: string, routeRunId: string): Promise<OpsRouteRun> {
  const response = (await makeRequest({
    url: `/ops/route-runs/${routeRunId}`,
    method: HttpMethods.GET,
    params: { organization_id: organizationId },
  })) as GenericResponse<OpsRouteRun>;
  return response.result;
}
